module.exports = flarum.core.compat['nickNames/components/NickNameModal'];